export default "__VITE_ASSET__BHSjpv6M__"